import { ReactElement } from 'react';
import cx from 'classnames';
import Header from './header';
import Sidebar from './sidebar';
import Container from './container';

import s from './styles.module.scss';

interface ILayout {
  collapsed: boolean;
  header: ReactElement;
  sidebar: ReactElement;
  content: ReactElement;
  sidebarToggle: () => void;
}

const Layout = ({ header, sidebar, content, collapsed, ...props }: ILayout) => {
  return (
    <div className={s.layout}>
      <div className={s.layoutSidebar}>
        <Sidebar collapsed={collapsed} {...props}>
          {sidebar}
        </Sidebar>
      </div>
      <div className={s.layoutMain}>
        <Header collapsed={collapsed} {...props}>
          {header}
        </Header>
        <div className={cx(s.layoutContainer, collapsed && s.layoutContainerCollapsed)}>
          <Container>{content}</Container>
        </div>
      </div>
    </div>
  );
};

export { Layout };
